<!--详情背景显示-->
<!--订单状态 status必传 -->
<template>
  <div>
    <div class="div-b" v-if="pointBuyType == 2 && pointDeductPrice > 0 " >
      <ul class="div-ul">
        <li>
          <van-row>
            <van-col span="8">积分抵扣</van-col>
            <van-col span="16" class="rig" style="color: #ed3939;">- {{pointDeductPrice}} 元</van-col>
          </van-row>
        </li>
        <li>
          <van-row>
            <van-col span="16">使用 <span style="color: #F08E3C;"> {{deInfo.totalExchangePoint}} </span>积分抵{{pointDeductPrice}}元</van-col>
          </van-row>
        </li>
      </ul>
    </div>
    <div class="div-b martop">
    <ul class="div-ul">
      <li v-if="keChuanInfoVO">
        <van-row type="flex" justify="end" align="center">
          <van-col span="8">同步科传信息</van-col>
          <van-col span="16" class="rig" @click="showDetail()">
            <van-tag plain type="warning" color="#999" class="look-tag"
              >查看详情</van-tag>
          </van-col>
        </van-row>
      </li>
   
      <li v-if="deInfo.outOrderCode">
        <van-row>
          <van-col span="8">品牌订单编号</van-col>
          <van-col span="13" class="rig">
            <a class="corl3" href="javascript:void(0);">{{deInfo.outOrderCode}}</a>
          </van-col>
          <van-col
            span="3"
            class="rig"
            @click="copyFun(deInfo.outOrderCode + '')"
          >
            <van-tag class="tag" plain type="warning">复制</van-tag>
          </van-col>
        </van-row>
      </li>
      <!-- 普通商品 -->
      <div v-if="!'2,3'.includes(buyType)">
        <li v-if="deInfo.commodityPrice">
          <van-row>
            <van-col span="8">商品总额</van-col>
            <van-col span="16" class="rig">￥{{ deInfo.commodityPrice }}</van-col>
          </van-row>
        </li> 
      
        <div v-show="deInfo.appSubOrderItemDetailVoList[0].isVirtual != 'y'">
          <li v-if="deInfo.lastRefundPrice">
            <van-row>
              <van-col span="8">退款总额</van-col>
              <van-col span="16" class="rig">￥{{ deInfo.lastRefundPrice }}</van-col>
            </van-row>
          </li>
          <li>
            <van-row>
              <van-col span="8" v-if="deInfo.isFreeShippingCn">运费（到付）</van-col>
              <van-col span="8" v-else>运费</van-col>

              <van-col span="16" v-if="deInfo.isFreeShippingCn" class="rig" style="color: #ed3939">到付</van-col>
              <van-col span="16" v-else class="rig">￥{{ deInfo.subFreight || 0.0 }}</van-col>
            </van-row>
          </li>
          <li :class="['dr', { dt: !(deInfo.saleAfterMode == 1 && deInfo.branchDeductionPrice > 0),},]"
            v-if="deInfo.orderType == 'NORMAL_ORDER'" >
            <van-row>
              <div>
                <van-col span="8">满减满折优惠</van-col>
                <van-col span="16" class="rig">-￥{{ deInfo.branchDeductionPrice || "0.00" }}</van-col>
              </div>
              <p class="drifo">
                {{deInfo.saleAfterMode == 1 && deInfo.branchDeductionPrice > 0 ? "售后须知：订单中包含满折活动的商品不支持退货": ""}}
              </p>
            </van-row>
          </li>

          <li v-if="deInfo.combinationDeductionPrice">
            <van-row>
              <van-col span="8">组合促销优惠</van-col>
              <van-col span="16" class="rig">-￥{{ deInfo.combinationDeductionPrice }}</van-col>
            </van-row>
          </li>

          <li v-if="deInfo.goodsActualPrice">
            <van-row>
              <van-col span="8">商品实收金额</van-col>
              <van-col span="16" class="rig">￥{{ deInfo.goodsActualPrice }}</van-col>
            </van-row>
          </li>

          <div>
            <li v-if="deInfo.platformDiscountPrice || deInfo.branchDiscountPrice || true">
              <van-row>
                <van-col span="8">满减券优惠 </van-col>
                <van-col span="16" class="rig">￥{{(Number(deInfo.platformDiscountPrice || 0) +  Number(deInfo.branchDiscountPrice || 0) ).toFixed(2)}}</van-col>
              </van-row>
            </li>
            <li v-if="deInfo.branchDiscountPrice || true">
              <van-row class="discount-price">
                <van-col span="24">店铺承担优惠金额  ￥{{deInfo.branchDiscountPrice || 0}}</van-col>
                <span class="top"></span>
                <!-- <van-col span="16" class="rig">￥{{deInfo.branchDiscountPrice || 0}}</van-col> -->
              </van-row>
            </li>
            
            <li v-if="deInfo.frightCouponValue">
              <van-row>
                <van-col span="8">运费券</van-col>
                <van-col span="16" class="rig"
                  >-￥{{ deInfo.frightCouponValue }}</van-col
                >
              </van-row>
            </li>
          </div>
        </div>
        <!-- <li v-if="deInfo.platformDiscountPrice">
          <van-row>
            <van-col span="8">优惠券</van-col>
            <van-col span="16" class="rig"
              >-￥{{ deInfo.platformDiscountPrice }}</van-col
            >
          </van-row>
        </li> -->
        <li v-if="deInfo.goodPrice">
          <van-row>
            <van-col span="8">商品金额</van-col>
            <van-col span="16" class="rig">￥{{ deInfo.goodPrice }}</van-col></van-row>
        </li>
      </div>
      <!-- 积分商品 -->
      <div v-if="'2,3'.includes(buyType)">
        <li v-if="pointBuyType != 2">
          <van-row>
            <van-col span="8">积分兑换价</van-col>
            <van-col span="16" class="rig">{{ deInfo.totalExchangePoint }} 积分</van-col>
          </van-row>
        </li>
        <li v-if="'2,3'.includes(buyType)">
          <van-row>
            <van-col span="8">商品金额</van-col>
            <van-col span="16" class="rig">￥{{ deInfo.commodityPrice }}</van-col>
          </van-row>
        </li> 
        <li>
          <van-row>
            <van-col span="8" v-if="deInfo.isFreeShippingCn">运费（到付）</van-col>
            <van-col span="8" v-else>运费</van-col>
            <van-col span="16" v-if="deInfo.isFreeShippingCn" class="rig" style="color: #ed3939">到付</van-col>
            <van-col span="16" v-else class="rig">￥{{ deInfo.subFreight || 0.0 }}</van-col>
          </van-row>
        </li>
      </div>

      <li class="heg" v-if="actualPrice">
        <van-row>
          <van-col span="9"> </van-col>
          <van-col span="15" class="rig price-point-font" >
            <span class=" item_connt">共<span class="red"> {{deInfo.totalItemCount}} </span>件</span>
            <span class="" style="color: #333;">{{ needPay ? "需付款：" : "实付款" }}</span>
            <!-- 积分+现金兑换 -->
            <span class="red" v-if="buyType == 3">
              <span v-if="pointBuyType == 2">
                {{actualPrice}}元
              </span>
              <span v-else>
                {{deInfo.totalExchangePoint}}积分+ {{actualPrice}}元</span>
              </span>
            <span class="red" v-else>￥{{ actualPrice }}</span>
          </van-col>
        </van-row>
      </li>

      <!-- 增加调账金额和共计金额 -->
       <li class="heg" v-if="deInfo.adjustSumPrice">
        <van-row>
          <van-col span="9"></van-col>
          <van-col span="15" class="rig">
            <span class="col9">调账总金额:</span>
            <span class="col9">￥{{deInfo.adjustSumPrice}}</span>
          </van-col>
        </van-row>
      </li>
       <li class="heg" v-if="deInfo.sumPrice && buyType != 3">
        <van-row>
          <van-col span="9"></van-col>
          <van-col span="15" class="rig">
            <span class="col9">共计:</span>
            <!-- <span class="red" style="font-size:14px;" v-if="buyType == 3">
              {{deInfo.totalExchangePoint}} 积分+ {{deInfo.sumPrice}}元</span> -->
            <span v-if="buyType == 2" class="red">{{deInfo.totalExchangePoint}}积分</span>
            <span v-else class="red">￥{{deInfo.sumPrice}}</span>
          </van-col>
        </van-row>
      </li>

      <!-- 礼品卡 -->
       <li class="heg" v-if="deInfo.totalGiftCardActualPrice">
        <van-row>
          <van-col span="9"></van-col>
          <van-col span="15" class="rig col9">
              <span v-if="deInfo.totalCashActualPrice">（现金￥{{deInfo.totalCashActualPrice}}，礼品卡抵扣￥{{deInfo.totalGiftCardActualPrice}}）</span>
              <span v-else>
                （礼品卡抵扣￥{{deInfo.totalGiftCardActualPrice}}）
              </span>
          </van-col>
        </van-row>

      </li>

    </ul>

    <!-- 科传详情弹窗 -->
    <van-action-sheet v-model="show" title="">
      <ul class="content_ul">
        <li>
          <span>科传销售单号</span>
          <span>{{ keChuanInfoVO && keChuanInfoVO.orderNo }}</span>
        </li>
        <li>
          <span>同步金额</span>
          <span>￥{{ keChuanInfoVO && keChuanInfoVO.price }}</span>
        </li>
        <!-- <li v-if="keChuanInfoVO && keChuanInfoVO.operationName">
          <span>操作蜜蜂</span>
          <span>{{ keChuanInfoVO && keChuanInfoVO.operationName }}</span>
        </li> -->
      </ul>
      <van-button class="back_btn" @click="show = !show">返回</van-button>
    </van-action-sheet>
    </div>
    <div class="div-b martop" >
      <ul class="div-ul">
        <li v-if="deInfo.subOrderCode">
        <van-row>
          <van-col span="8">订单编号</van-col>
          <van-col span="13" class="rig">
            <a class="corl3" href="javascript:void(0);">{{
              deInfo.subOrderCode
            }}</a>
          </van-col>
          <van-col
            span="3"
            class="rig"
            @click="copyFun(deInfo.subOrderCode + '')"
          >
            <van-tag class="tag" plain type="warning">复制</van-tag>
          </van-col>
        </van-row>
      </li>
      <li v-if="createTime">
        <van-row>
          <van-col span="8">下单时间</van-col>
          <van-col span="16" class="rig">{{ createTime }}</van-col>
        </van-row>
      </li>
      <li v-if="payTime && !needPay">
        <van-row>
          <van-col span="8">付款时间</van-col>
          <van-col span="16" class="rig">{{ payTime }}</van-col>
        </van-row>
      </li>
      <li v-if="deInfo.payType && buyType != 2">
        <van-row>
          <van-col span="8">支付方式</van-col>
          <van-col span="16" class="rig" v-if="deInfo.payType == 'ALIPAY'"
            >支付宝</van-col
          >
          <van-col span="16" class="rig" v-else>微信</van-col>
        </van-row>
      </li>
      </ul>
    </div>
  </div>

</template>
<script>
import Util from "@/utils/common";
export default {
  props: {
    deInfo: {
      type: Object,
      default: () => {
        return {
          appSubOrderDetailVoList: [{}],
        };
      },
      required: true,
    },
    //默认为子订单的格式显示
    orderId: {
      default: false,
    },
    yunfeiPay: {
      default: 0,
    },
    payTime: {
      default: false,
    },
    createTime: {
      default: false,
    },
    buyType:{
      default:1,
      type:Number
    },
    needPay: {
      default: false,
    },
    actualPrice: {
      default: false,
    },
    keChuanInfoVO: {
      default: false,
    },
    pointBuyType:{
      type: Number,
      default: 1,
    },
    pointDeductPrice:{
      type: Number,
      default: 0, 
    }
  },
  watch: {},
  data() {
    return {
      info: {},
      show: false,
    };
  },
  methods: {
    copyFun(code) {
      Util.copyText(code);
    },
    showDetail() {
      if (this.keChuanInfoVO) {
        this.show = !this.show;
      }
    },
  },
  created() {
    setTimeout(() => {
      console.log(this.deInfo);
    }, 6000);
  },
  components: {},
  computed: {},
};
</script>
<style lang="less" scoped>
.martop{
  margin-top: 20px;
}
.div-b {
  font-size: 0.3rem;
  background-color: #fff;
  padding: 40px;
  text-align: left;
  .div-ul > li {
    height: 46px;
    line-height: 46px;
  }
  /deep/ .tag {
    // height: 28px;
    // line-height: 28px;
    // width: 54px;
    padding: 4px 10px;
    color: #f8a651;
    font-size: 20px;
    border-radius: 6px;
    text-align: center;
  }
}
.van-row {
  margin-bottom: 0.2rem;
  .rig {
    text-align: right;
  }
}
.mt-5 {
  margin-bottom: 0.2rem;
}
.col9 {
  color: #999999;
}
.corl3 {
  color: #333;
}
.heg {
  height: 40px;
  line-height: 40px;
}
.red {
  color: #ed3939;
  font-size: 32px;
  font-weight: bold;
}
.div-b .div-ul > li.dr {
  height: 90px;
  .drifo {
    color: #f8a651;
    font-size: 20px;
  }
}
.div-b .div-ul > li.dr.dt {
  height: 42px;
}
.content_ul {
  padding: 81px 70px 0;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 44px;
  li {
    display: flex;
    justify-content: space-between;
    margin-bottom: 30px;
  }
}
.back_btn {
  width: 300px;
  height: 70px;
  background: var(--epButtonColor);
  color: var(--epTextColor);
  border-radius: 40px;
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  line-height: 33px;
  margin: 0 auto;
  display: block;
  margin-bottom: 60px;
  margin-top: 70px;
}
.look-tag {
  padding: 5px 15px;
  border-radius: 10px;
}
.item_connt{
  margin-right: 20px;
  font-size: 26px;
  color: #333;
}  
.discount-price{
  color: #999;
  background: #F7F7F7;
  border-radius: 10px;
  padding: 16px 24px;
  position: relative;
  .top{
    display: inline-block;
    position: absolute;
    top: -26px;
    left: 24px;
    width: 0;
    height: 0;
    border: 14px solid;
    border-color: rgba(0,0,0,0) rgba(0,0,0,0) #f7f7f7 rgba(0,0,0,0);
  }
}
.price-point-font{
  font-size: 26px;
  color: #333;
  .red{
    font-size: 26px;
    font-weight: 500;
    font-family:DINAlternate-Bold, DINAlternate;
  }
}
</style>